import React from 'react';
import Image from 'src/components/Image';

const socialProof = (props) => {
  const logoCount = props['logos'].length;
  return (
    <div
      className={`${props['uses-wrapper-class'] ? 'social-proof-wrapper' : 'social-proof'} ${
        props['is-light'] ? 'social-proof-inverted' : ''
      }`}
    >
      <div className='grid-container'>
        <div className={`grid-x ${props['uses-margin-class'] && 'grid-margin-x'}${props['alignment'] && ` align-${props.alignment}`}`}>
          <div className={`cell small-12 ${props['full-width'] ? '' : 'medium-8'}${props['uses-container-class'] ? ' social-proof-container' : ''}`}>
            {props['text'] && (
              <p className="social-proof-text social-proof-text--padding-bottom social-proof-text--large-style" dangerouslySetInnerHTML={{ __html: props.text }} />
            )}
            <h6 className={`${props['uses-section-title-class'] ? 'section-title' : ''}`}>{props.header}</h6>
            <div
              className={`grid-x small-up-2 medium-up-${
                props['column-count'] ? props['column-count'] : logoCount}${props['alignment'] && ` align-${props.alignment}`}`}
            >
              {props['logos'].map((logo, i) => {return (
                <React.Fragment key={`logos-${i}`}>
                  <div className={`cell social-proof-logo${logo['container-classes'] ? ` ${logo['container-classes']}` : ''}`}>
                    <Image src={logo.img} alt={logo.alt} width={logo.width} height={logo.height}/>
                  </div>
                </React.Fragment>
              )})}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default socialProof;
